import {
  GraduationCap,
  MessageSquareHeart,
  Briefcase,
  Puzzle,
  Scale,
  BookOpen,
  Sparkles,
} from "lucide-react";
import type { BannerVariant } from "../pageBannerConfig";

const ICONS: Record<BannerVariant, typeof Sparkles> = {
  default: Sparkles,
  catalog: GraduationCap,
  coaching: MessageSquareHeart,
  fractional: Briefcase,
  microservices: Puzzle,
  legal: Scale,
  editorial: BookOpen,
};

export function BannerMotif({ variant }: { variant: BannerVariant }) {
  const Icon = ICONS[variant] ?? Sparkles;
  return (
    <div
      aria-hidden="true"
      className="pointer-events-none relative hidden h-32 w-32 shrink-0 md:block lg:h-40 lg:w-40"
    >
      <svg
        viewBox="0 0 160 160"
        className="absolute inset-0 h-full w-full text-primary/30"
        fill="none"
      >
        <defs>
          <radialGradient id="bm-glow" cx="50%" cy="50%" r="50%">
            <stop offset="0%" stopColor="currentColor" stopOpacity="0.45" />
            <stop offset="60%" stopColor="currentColor" stopOpacity="0.12" />
            <stop offset="100%" stopColor="currentColor" stopOpacity="0" />
          </radialGradient>
        </defs>
        <circle cx="80" cy="80" r="78" fill="url(#bm-glow)" />
        <circle cx="80" cy="80" r="58" stroke="currentColor" strokeOpacity="0.35" />
        <circle cx="80" cy="80" r="42" stroke="currentColor" strokeOpacity="0.25" />
        <circle cx="80" cy="80" r="26" stroke="currentColor" strokeOpacity="0.2" />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        <Icon className="h-10 w-10 text-primary lg:h-12 lg:w-12" strokeWidth={1.5} />
      </div>
    </div>
  );
}
